import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

class AuthService {
  static async forgotPassword(email: string): Promise<void> {
    try {
      await axios.post(`${API_BASE_URL}/PasswordReset/forgot-password`, {
        email,
      });
    } catch (error) {
      console.error("Password reset request failed:", error);
      throw new Error("Error al solicitar recuperación de contraseña");
    }
  }

  static async resetPassword(
    token: string,
    newPassword: string,
    confirmPassword: string
  ): Promise<void> {
    try {
      await axios.post(`${API_BASE_URL}/PasswordReset/reset-password`, {
        token,
        newPassword,
        confirmPassword,
      });
    } catch (error) {
      console.error("Password reset failed:", error);
      if (axios.isAxiosError(error) && error.response) {
        throw new Error(
          error.response.data || "Error al restablecer contraseña"
        );
      }
      throw new Error("Error de conexión al restablecer contraseña");
    }
  }
}

export default AuthService;
